import Thumbnail from './Thumbnail';
export default Thumbnail;
